import {createSelector} from 'reselect';
import {sortBy, take} from 'lodash';
import Fuse from 'fuse.js';

const fxData = state => state.fxData;
const pageSize = state => state.pageSize;
const searchTerm = state => state.searchTerm;

const sortedFxData = createSelector([fxData], (data) => {
  return sortBy(data, ['participant_name']);
});

const fxDataBySearchTerm = createSelector([sortedFxData, searchTerm], (data, searchTerm) => {
  if (searchTerm.length <= 3) {
    return data;
  }

  const fuse = new Fuse(data, {
    minMatchCharLength: 3,
    keys: ['participant_name'],
    threshold: 0.3
  });

  return fuse.search(searchTerm).map(e => e.item);
});

export const fxDataList = createSelector([fxDataBySearchTerm, pageSize], (data, pageSize) => {
  return take(data, pageSize);
})